export class BrakeCheckHelper {
    public brakeTypes = { Disc: 'Disc', Drum: 'Drum', DiscAndDrum: 'Disc and Drum' };
    public exemptionTypes = { NotExempt: 'Not Exempt', ExemptScheduled: 'Exempt (Scheduled)', ExemptNotRequired: 'Exempt (N/A)' };
    public schedules = { Week1: 'Week 1', Week2: 'Week 2', Both: 'Both' };
}

export default new BrakeCheckHelper();
